// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EndResultsCard_wrapper__Hoj7A","title":"EndResultsCard_title__69lJd","description":"EndResultsCard_description__1tJBJ"};